import React from 'react';
import { useContext } from 'react';
import { Redirect } from "react-router-dom";
import { AddressContainer } from "./Addresses/AddressContainer";
import { AlertsContainer } from "./Services/AlertsContainer";
import { UserCredentials } from './UserCredentials/UserCredentials';
import { UserRecapData } from './RecapUserData/UserRecapData';
import { getToken, saveToken } from './Hooks/Token';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthContext } from "../AuthContext";
import { NavLink } from "react-router-dom";
import { Button, Modal } from 'react-bootstrap';
import { getAPI } from './GdacsAPI';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import ReCAPTCHA from 'react-google-recaptcha';

dayjs.extend(utc);



const RegisterComponent = (props) => {//componente principale
    const authContext = useContext(AuthContext);
    const [responseMessage, setResponseMessage] = React.useState("");
    const params = authContext.data ? authContext.data : !props.params ? props.location.state : props.params;
    const [navIndex, setNavIndex] = React.useState(!props.navIndex ? 1 : props.navIndex);
    const navMax = 5;
    const navMin = 0;
    const navStep = 1;
    const initialObject = {
        idUser: 0, username: "", password: "", firstName: "", lastName: "", email: "", country: "", organisation: "", orgtype: "", emailOption: "", notes: "", utcOffset: 0, enabled: false, status: "", otp: "",
        addresses: [], services: []
    }
    const [userData, setUserData] = React.useState(!params ? initialObject : params);
    const userDataRef = React.useRef({ username: '', password: '', firstName: '', lastName: '', emailp: '', adress: '', company: '' });
    const [isDisabled, setIsDisabled] = React.useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
    const [isValidForm, setIsValidForm] = React.useState({ usernamepassword: false, customdata1: false, customdata2: false });
    const [isValidAll, setIsValidAll] = React.useState(false);
    const [isRegistered, setIsRegistered] = React.useState(false);
    const [isSaved, setIsSaved] = React.useState(false);
    const [show, setShow] = React.useState(false);
    const [showValidate, setShowValidate] = React.useState(false);
    const [isToValidate, setIsToValidate] = React.useState(false);
    const [otpError, setOtpError] = React.useState("");

    const captchaRef = React.useRef(null);
    const [captchaValid, setCaptchaValid] = React.useState(false);
    const [captchaToken, setCaptchaToken] = React.useState("");
    const isOtpValid =
        userData?.idUser !== 0 ||
        userData?.codeotp?.length === 10;


    const handleCaptchaChange = (token) => {
        setCaptchaToken(token || "");
        setCaptchaValid(!!token);
    };


    React.useEffect(() => {
        setIsValidAll(isValidForm.usernamepassword && isValidForm.customdata1 && isValidForm.customdata2);
    }, [isValidForm]);

    const handleOnChangeGenericPropertyTable = (key, value) => {
        setUserData(u => {
            let user = { ...u };
            user[key] = value;
            return user;
        });
    }

    const handleOnChangeGenericProperty = (componentstate) => {
        setUserData(componentstate);
    }

    // const handleOnChangeUsernamePassword = (credential) => {
    //     setUserData(u => ({ ...u, username: credential.username, password: credential.password }));
    // }

    const handleChangeValidation = (credentials) => {
        if (credentials.firstName === undefined || credentials.firstName === "")
            setIsButtonDisabled(true);
        else if (credentials.lastName === undefined || credentials.lastName === "")
            setIsButtonDisabled(true);
        else if (credentials.email === undefined || credentials.email === "")
            setIsButtonDisabled(true);
        else if (credentials.country === undefined || credentials.country === "")
            setIsButtonDisabled(true);
        else
            setIsButtonDisabled(false);
    }

    const handleChangeButton = (state) => {
        setIsButtonDisabled(state);
    }


    const handleChangeValid = (componentValidateNumberd, v) => {
        //handle button, tab, alert, submit button
        setIsValidForm(v => {
            let userDataUpdate = { ...v };
            userDataUpdate[componentValidateNumberd] = v;
            return userDataUpdate;
        });
    }
    //// --- NAVIGATION
    const handleNavigationClick = (e) => {
        switch (e.target.value) {
            case 'prev':
                setNavIndex(v => v - navStep > navMin ? v - navStep : navMin);
                break;
            case 'next':
                setNavIndex(v => v + navStep < navMax ? v + navStep : navMax);
                break;
        }
    }
    //// ---

    const handleSubmit = () => {

        setOtpError("");
        setResponseMessage("");

        if (userData?.idUser === 0) {

            if (!userData?.codeotp || userData.codeotp.length !== 10) {
                setOtpError("Please insert a valid OTP code.");
                return;
            }

            if (!captchaToken) {
                setOtpError("Please complete the CAPTCHA.");
                return;
            }
        }

        SaveRecord(userData);
    };
 

    async function SaveRecord(userData) {

        let address = [];
        for (let i = 0; i < userData.addresses.length; i++) {
            address.push({
                idUserAddress: userData.addresses[i].idUserAddress, idUser: userData.idUser, idServiceType: userData.addresses[i].idServiceType, addressOption: userData.addresses[i].addressOption,
                deviceKey: userData.addresses[i].deviceKey === "", addressValue: userData.addresses[i].addressValue, checkcode: userData.addresses[i].checkcode,
                checkvalidate: userData.addresses[i].checkvalidate, checkdate: userData.addresses[i].checkdate
            });
            if (userData.addresses[i].idServiceType === 1 || userData.addresses[i].idServiceType === 3) {
                if (userData.addresses[i].checkvalidate === false)
                    setIsToValidate(true);
            }
        }


        let services = [];
        for (let i = 0; i < userData.services.length; i++) {
            services.push({
                idService: userData.services[i].idService, idUser: userData.idUser, idServiceType: userData.services[i].idServiceType,
                eventType: userData.services[i].eventType, alertLevel: userData.services[i].alertLevel, region: userData.services[i].region, language: userData.services[i].language,
                stopNight: userData.services[i].stopNight, enabled: userData.services[i].enabled
            });
        }

        let json = {
            idUser: userData?.idUser,
            lastName: userData?.lastName,
            firstName: userData?.firstName,
            country: userData?.country,
            enabled: userData?.enabled,
            email: userData?.email,
            emailOption: userData?.emailOption,
            username: userData?.username,
            password: userData?.password,
            notes: userData?.notes,
            organisation: userData?.organisation,
            orgtype: userData?.orgtype,
            status: userData?.idUser ? "confirmed" : "waiting",
            datemodified: dayjs.utc().format("YYYY-MM-DDTHH:mm:ss"),
            utcOffset: userData?.utcOffset,
            addresses: address,
            services: services,
            token: userData?.token ? userData.token : "",
            otp: userData.codeotp ? userData.codeotp : ""
        };


        const settings = (!userData?.idUser)
            ? {
                method: 'POST',
                body: JSON.stringify(json),
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'token-captcha': captchaToken
                }
            }
            : {
                method: 'POST',
                body: JSON.stringify(json),
                headers: {
                    'Authorization': 'Bearer ' + getToken(),
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            };



        const api = (!userData?.idUser) ? getAPI() + `api/register/Users/create` : getAPI() + `api/register/Users/update`;
        const response = await fetch(api, settings);

        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            setIsSaved(undefined);
            return;
        }
        else {
            const resp = await response.json();
            setResponseMessage(resp.message);
            if (userData.idUser !== 0)
                authContext.update(resp);
            setShow(true);
        }
    }

    const handleCheckConditions = (value) => {
        setIsDisabled(!value);
    }


    const handleClose = (isToValidate) => {
        if (isToValidate === true) {
            setShow(false);
            setShowValidate(true);
        }
        else {
            setShowValidate(false);
            setShow(false);
        }
        setIsRegistered(true);
    }

    React.useEffect(() => {
        console.log("isDisabled", isDisabled);
    }, [isDisabled]);

    React.useEffect(() => {

    }, [isButtonDisabled]);

    if (isRegistered) {
        if (!userData?.idUser) {
            authContext.logout();
            return <Redirect to={"/"} />
        }
    }

    return (<div className="alerts_container col-12">
        <br />
        {
            navIndex === 1 && <UserCredentials
                params={userData}
                navIndex={navIndex}
                onChange={handleOnChangeGenericProperty}
                onChangeValid={v => handleChangeValid('customdata1', v)}
                onChangeField={handleChangeValidation} />
        }

        {
            navIndex === 2 && <AddressContainer
                params={userData}
                navIndex={navIndex}
                isButtonDisabled={handleChangeButton}
                onChange={handleOnChangeGenericPropertyTable}
                onChangeValid={v => handleChangeValid('customdata2', v)} />
        }
        {
            navIndex === 3 && <AlertsContainer
                params={userData}
                navIndex={navIndex}
                isButtonDisabled={handleChangeButton}
                onChange={handleOnChangeGenericPropertyTable}
                onChangeValid={v => handleChangeValid('customdata3', v)} />
        }
        {
            navIndex === 4 && <UserRecapData
                params={userData}
                navIndex={navIndex}
                onChange={handleOnChangeGenericProperty}
                onChangeValid={v => handleChangeValid('customdata4', v)}
                handleCheck={handleCheckConditions}
                captchaValid={captchaValid}
                captchaRef={captchaRef}
                handleCaptchaChange={handleCaptchaChange}
                otpError={otpError}
            />
        }
        <br />
        {/*{responseMessage &&*/}
        {/*    <div className="input-feedback">{responseMessage}</div>*/}
        {/*}*/}
        {
            responseMessage &&
            !show &&
            <div
                className="input-feedback text-danger mb-3"
                style={{ textAlign: "center" }}
            >
                {responseMessage}
            </div>
        }
        <div className="form-row">
            <div className="col-6">
                {
                    navIndex > 1 &&
                    <div style={{ paddingLeft: "20px" }}>
                        <button id="prev" type="button" value="prev" className="btn btn-primary" style={{ minWidth: "80px" }} onClick={handleNavigationClick} disabled={isButtonDisabled}>Prev</button>
                    </div>
                }
            </div>
            <div className="col-6">
                {
                    navIndex < 4 &&
                    <div style={{ paddingRight: "20px" }}>
                        <button id="next" type="button" value="next" className="float-right btn btn-primary" style={{ minWidth: "80px" }} onClick={handleNavigationClick} disabled={isButtonDisabled}>Next</button>
                    </div>
                }
                {
                    navIndex === 4 &&
                    <div
                        className="d-flex justify-content-between align-items-center w-100"
                        style={{
                            width: "100%",
                            paddingRight: "20px",
                            textAlign: "end"
                        }}
                    >

{/*                         {
                            userData?.idUser === 0 &&
                            <form className="captcha mb-0">
                                <ReCAPTCHA
                                    sitekey={process.env.REACT_APP_SITE_KEY}
                                    ref={captchaRef}
                                    onChange={handleCaptchaChange}
                                />
                            </form>
                        } */}

                            <button
                                id="confirm"
                                type="button"
                                className="float-right btn btn-info"
                                onClick={handleSubmit}
                                disabled={
                                    userData?.idUser === 0
                                        ? (
                                            !captchaValid ||
                                            !isOtpValid ||
                                            isDisabled
                                        )
                                        : isDisabled
                                }
                            >
                                Submit
                            </button>

                    </div>
                }
            </div>
        </div>
        <Modal className="d-flex justify-content-left" show={show} onHide={handleClose} >
            <Modal.Header closeButton>
                <Modal.Title>User Account</Modal.Title>
            </Modal.Header>
            <><Modal.Body>{userData.idUser === 0 ? responseMessage : "Data User account saved correctly."}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleClose(isToValidate)}>
                        OK
                    </Button>
                </Modal.Footer></>
        </Modal>
        <Modal show={showValidate} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Validate Your Number</Modal.Title>
            </Modal.Header>
            <><Modal.Body>To receive the GDACS alerts, first you need to validate your channels.
                Do you want to do it now?</Modal.Body>
                <Modal.Footer>
                    <NavLink
                        to={{
                            pathname: '/ValidateContainer',
                            origin: "Register",
                        }}
                        className="btn btn-primary " >
                        Yes
                    </NavLink>
                    <Button variant="secondary" onClick={handleClose}>
                        No
                    </Button>
                </Modal.Footer></>
        </Modal>
        <br />
        <br />
    </div>);
}
export { RegisterComponent }
